module.exports = "<div [class.loader-hidden]=\"!show\">\r\n  <div class=\"loader-overlay\" *ngIf=\"show\">\r\n    <div>\r\n      <div class=\"progress-materializecss\">\r\n        <div class=\"indeterminate\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_common/loader/loader.component.html
// module id = ../../../../../src/app/_common/loader/loader.component.html
// module chunks = main